import { Organization } from './organization.model';

export enum WorkExperienceType {
  EDUCATION = 'EDUCATION',
  EXPERIENCE = 'EXPERIENCE',
}

export class JobTitle {
  active: boolean;
  createdBy: string;
  name: string;
  constructor(json: any) {
    this.active = json.active;
    this.createdBy = json.createdBy;
    this.name = json.title;
  }
}

export class WorkExperience {
  active: boolean;
  employmentTenure: string;
  id: string;
  isCurrentlyWorking: boolean;
  jobDescription: string;
  jobTitle: JobTitle;
  organization: Organization;
  type: WorkExperienceType;
  constructor(json: any) {
    this.active = true;
    this.employmentTenure = json.employmentTenure;
    this.id = json.id || json._id;
    this.isCurrentlyWorking = json.isCurrentlyWorking;
    this.jobDescription = json.jobDescription;
    this.jobTitle = new JobTitle(json.jobTitle);
    this.organization = new Organization(json.organization);
    this.type = json.type;
  }
}

export type GroupedWorkExperienceByOrganization = {
  [organizationId: string]: {
    organization: Organization;
    roles: WorkExperience[];
  };
};
